export {
  useEducationalContentStatus,
  useSaveEducationalContentStatus,
} from './useEducationalContent';
